import Map from 'ol/Map';
import View from 'ol/View';
import { register } from 'ol/proj/proj4';
import proj4 from 'proj4';

class CustomMap extends Map {
    constructor (props) {
        super(props);
        // via https://epsg.io/29903 etc
        proj4.defs('EPSG:27700', '+proj=tmerc +lat_0=49 +lon_0=-2 +k=0.9996012717 +x_0=400000 +y_0=-100000 +ellps=airy +towgs84=446.448,-125.157,542.06,0.15,0.247,0.842,-20.489 +units=m +no_defs');
        proj4.defs('EPSG:29902', '+proj=tmerc +lat_0=53.5 +lon_0=-8 +k=1.000035 +x_0=200000 +y_0=250000 +a=6377340.189 +rf=299.3249646 +towgs84=482.5,-130.6,564.6,-1.042,-0.214,-0.631,8.15 +units=m +no_defs +type=crs');
        proj4.defs('EPSG:29903', '+proj=tmerc +lat_0=53.5 +lon_0=-8 +k=1.000035 +x_0=200000 +y_0=250000 +a=6377340.189 +rf=299.3249646 +towgs84=482.5,-130.6,564.6,-1.042,-0.214,-0.631,8.15 +units=m +no_defs +type=crs');
        register(proj4);
        const view = new View({ enableRotation: false });
        this.setView(view);
        this.getLayerById = id => {
            const layers = this.getLayers();
            return Array.from(layers).find(layer => layer.get('id') === id);
        };
    }
}

export default CustomMap;
